import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { Constants } from 'core';

import { createProfil, createdProfil, updateProfil, updatedProfil, deleteProfil, deletedProfil } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';
import { getProfilesSaga } from '../profiles/saga';
import { fetchPofiles } from '../profiles/actions';
import { sagaWithCallback } from '../utils';

type CreateProfilActionPayload = ReturnType<typeof createProfil>;
type ModifyProfilActionPayload = ReturnType<typeof updateProfil>;
type DeleteProfilActionPayload = ReturnType<typeof deleteProfil>;

export function* createProfileSaga({ payload }: CreateProfilActionPayload) {
  const { createProfilApi } = getAPI();
  const response: YieldOf<typeof createProfilApi> = yield call(createProfilApi, payload);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(createdProfil(data));
    return data;
  } else {
    const error =
      status === Constants.ALREADY_EXISTED_STATUS ? Constants.ALREADY_EXISTED_PROBLEM_CODE : problem || 'unknown';
    yield put(createdProfil(undefined, error));
    throw new Error('create profil failed: ' + error);
  }
}

export function* modifyProfileSaga({ payload }: ModifyProfilActionPayload) {
  const { modifyProfilApi } = getAPI();
  const response: YieldOf<typeof modifyProfilApi> = yield call(modifyProfilApi, payload);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(updatedProfil(data));
    return data;
  } else {
    const error =
      status === Constants.ALREADY_EXISTED_STATUS ? Constants.ALREADY_EXISTED_PROBLEM_CODE : problem || 'unknown';
    yield put(updatedProfil(undefined, error));
    throw new Error('modify profil failed: ' + error);
  }
}

function* deleteProfilsSaga({ payload }: DeleteProfilActionPayload) {
  const { deleteProfilApi } = getAPI();
  const response: YieldOf<typeof deleteProfilApi> = yield call(deleteProfilApi, payload.id);
  const { ok, problem, status, data } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield call(getProfilesSaga, fetchPofiles());
    yield put(deletedProfil(undefined));
  } else {
    const error = data || problem || 'unknown';
    yield put(deletedProfil(error));
  }
}

export default function* ProfilesSaga() {
  yield takeLatest(createProfil.type, sagaWithCallback(createProfileSaga));
  yield takeLatest(updateProfil.type, sagaWithCallback(modifyProfileSaga));
  yield takeLatest(deleteProfil.type, deleteProfilsSaga);
}
